import React from 'react'
import { useTranslation } from 'react-i18next'

import app_store from 'img/app-store.png'
import google_play from 'img/google-play.png'

import { getMobileOperatingSystem } from 'shared/index'
import { Heading } from '../../../../components/index'

const AppDownloadSection = () => {
	const { t } = useTranslation()
	const op = getMobileOperatingSystem()
	return (
		<section className="container my-5 section-app">
			<Heading title={'ActivatedCard'} />
			<div className="my-4">{t('ActivatedCardText')}</div>
			<div className="app-links">
				<div>
					{(op === 'iOS' || op === 'unknown') && (
						<a
							href="http://appstore.com/tfbankmobile"
							target="_blank"
							rel="noopener noreferrer">
							<img src={app_store} alt="apple-store" />
						</a>
					)}
					{(op === 'Android' || op === 'unknown') && (
						<a
							href="https://play.google.com/store/apps/details?id=se.tfbank.tfbankmobile"
							target="_blank"
							rel="noopener noreferrer">
							<img src={google_play} alt="goolge-store" />
						</a>
					)}
				</div>
			</div>
		</section>
	)
}

export default AppDownloadSection
